module.exports = __webpack_public_path__ + "img/accounts.50577469.svg";